import { INITIAL_DATA_LOADERS } from '@wix/form-fields/controller';
import { fetchAddressForms } from '../../services/fetch-address-forms';
import { hasMultilineAddress } from '../../services/has-multiline-address';
import { defaultLocaleDatasetLoader } from '../../services/load-translations';
import { toError } from '../common/error';
import { fetchForms } from './fetch-forms';
export const getLocaleDataset = async ({ allForms, language, localeDatasetLoader, errorMonitor })=>{
    const updatedLocaleDatasetLoader = localeDatasetLoader ?? defaultLocaleDatasetLoader(allForms, language, errorMonitor);
    return updatedLocaleDatasetLoader();
};
export const getAddressTemplates = async ({ forms, existingAddressTemplates, httpClient, errorHandler, excludeEcomAddress = false, signal })=>{
    const hasMultilineAddressInForms = forms.some((f)=>hasMultilineAddress(f, {
            excludeEcomAddress
        }));
    if (hasMultilineAddressInForms && !existingAddressTemplates) {
        return fetchAddressForms(httpClient, errorHandler, signal);
    }
    return existingAddressTemplates;
};
export const getFieldInitialData = async ({ forms, httpClient, errorHandler, environment, experiments, bi, signal })=>{
    const loaders = Object.entries(INITIAL_DATA_LOADERS).filter(([fieldType])=>forms.some((form)=>form.fields?.some((field)=>fieldType === field.view?.fieldType)));
    return Promise.all(loaders.map(async ([fieldType, loader])=>{
        const form = forms.find((f)=>f.fields?.some((field)=>field.view?.fieldType === fieldType));
        if (!form) {
            return [
                fieldType,
                undefined
            ];
        }
        const result = await loader({
            httpClient,
            errorHandler,
            form,
            isEditor: environment.isEditor,
            experiments,
            bi: bi ?? undefined,
            signal
        });
        return [
            fieldType,
            result
        ];
    })).then((results)=>results.reduce((acc, [fieldType, result])=>{
            acc[fieldType] = result;
            return acc;
        }, {}));
};
export const loadAdditionalForms = async ({ namespace, formIds, additionalMetadata, formKind, httpClient, errorMonitor, errorHandler, language, signal })=>{
    try {
        if (!formIds || formIds.length === 0) {
            return null;
        }
        const newFormsById = await fetchForms({
            formIds,
            formKind,
            namespace,
            httpClient,
            errorMonitor,
            throwWhenFormMissing: false,
            additionalMetadata,
            errorHandler,
            language,
            signal
        });
        const newForms = Object.values(newFormsById).filter(Boolean);
        if (newForms.length === 0) {
            return null;
        }
        return newFormsById;
    } catch (error) {
        console.error('Error loading additional forms:', error);
        errorMonitor.captureException(toError(error));
        return null;
    }
};

//# sourceMappingURL=load-forms.js.map